/*
 * Author: Stephen Aranda
 * File  : trader-reducer.jsx
 * Desc  : reducer function for the trader action suite/
 */

import {
    TRADER_START,
    TRADER_SUCCESS,
    TRADER_FAILURE
} from "../actions/trader-actions";

const initialState = {
    trader: {},
    loading: false,
    error: ""
}


// reducer function for trader action suite
const traderReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRADER_START:
            return { ...state, loading: true };
        case TRADER_SUCCESS:
            return { ...state, trader: action.payload, loading: false };
        case TRADER_FAILURE:
            return { ...state, error: action.payload, loading: false };
        default:
            return state;
    }

}

export default traderReducer;